import Immutable from 'immutable';
import _ from 'lodash';
import AuthConstants from '../constants/AuthConstants';

const initialState = Immutable.Map({
  currentUserId: null,
  loginOverlayOpen: false,
  postLoginAction: null,
  loading: false
});

export default function auth(state = initialState, action) {
  let nextState = state;
  if (nextState.getIn(['middlewareData', 'authRequired'])) {
    // Always update the postLoginAction incase the action is fired after the session expires
    nextState = nextState.set('postLoginAction', action);
  }

  if (['invalid_token', 'RailsSessionInvalidationException'].includes(_.get(action, 'payload.error.classification'))) {
    // This happens when the user's session has expired
    return nextState.merge({
      loginErrorMessage: `errors.${action.payload.error.classification}`,
      currentUserId: null,
      loginOverlayOpen: true
    });
  }

  switch (action.type) {

    case AuthConstants.AUTH_LOAD_USER_FAILURE: {
      return initialState;
    }

    case AuthConstants.AUTH_LOAD_USER_SUCCESS: {
      return state.merge(action.payload.auth);
    }

    case AuthConstants.AUTH_LOGIN_SUCCESS: {
      return state.merge({
        currentUserId: action.payload.auth.currentUserId,
        loginErrorMessage: null,
        loginOverlayOpen: false,
        loading: false
      });
    }

    case AuthConstants.AUTH_LOGIN_ERROR: {
      return state.merge({
        currentUserId: action.payload.currentUserId,
        loginErrorMessage: action.payload.error && action.payload.error.message, // TODO: default message?
        loginOverlayOpen: true,
        loading: false
      });
    }

    case AuthConstants.AUTH_LOGOUT: {
      return initialState;
    }

    case AuthConstants.OPEN_LOGIN_OVERLAY: {
      return state.merge({
        loginErrorMessage: null,
        loginOverlayOpen: true,
        postLoginAction: action.payload.postLoginAction
      });
    }

    case AuthConstants.CLOSE_LOGIN_OVERLAY: {
      return state.merge({
        loginErrorMessage: null,
        loginOverlayOpen: false,
        postLoginAction: null
      });
    }

    case AuthConstants.AUTH_LOGIN_REQUEST: {
      return state.merge({
        loading: true
      });
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/AuthReducer.js